"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddNote = void 0;
var _react = _interopRequireDefault(require("react"));
var _NoteAddOutlined = _interopRequireDefault(require("@material-ui/icons/NoteAddOutlined"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _wbmInputs = require("wbm-inputs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var AddNote = exports.AddNote = function AddNote(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return !props.added ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    arrow: true,
    placement: "bottom",
    title: props.tooltipText
  }, /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    className: "btn-primary round",
    onClick: props.onClick
  }, /*#__PURE__*/_react["default"].createElement(_NoteAddOutlined["default"], null))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    className: "round add-note-added",
    onClick: props.onClick
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "material-icons"
  }, "task")));
};
//# sourceMappingURL=addNote.js.map